import axiosInstance from '@/services/apiService';

// Define the endpoint for getting current user details
const GET_USER_ENDPOINT = '/users/me';

/**
 * Function to get current user details by calling the /api/users/me endpoint.
 *
 * @returns {Promise<Object>} - The response containing the UserDto.
 */
const getCurrentUser = async () => {
    try {
        const response = await axiosInstance.get(GET_USER_ENDPOINT);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch user details:', error);
        throw error;
    }
};

export default {
    getCurrentUser,
};